// Single source of truth for brand & business info.
export const BRAND = {
  name: "New Varsha Sarees",
  nameHindi: "न्यू वर्षा साड़ीज",
  tagline: "We breathe in colours and elegance…",
  whatsappNumber: "918889645151",
  whatsappDisplay: "+91 88896 45151",
  email: "newvarshasarees.s@gmail.com",
  instagram: "https://www.instagram.com/newvarshasarees/",
  facebook: "https://www.facebook.com/newvarshasarees/",
  maps: "https://share.google/WkSoN3Z1qxpI7BZnD",
  address: {
    line1: "G-1, Harsh Apartment, 582, Kalani Nagar",
    line2: "Near Digambar Jain Mandir, Airport Road",
    city: "Indore, Madhya Pradesh",
    hindi: "G-1, हर्ष अपार्टमेन्ट, 582, कालानी नगर, दिगम्बर जैन मन्दिर के पास, एयरपोर्ट रोड, इन्दौर",
  },
  hours: [
    { day: "Mon – Sat", time: "10:30 AM – 9:00 PM" },
    { day: "Sunday", time: "11:00 AM – 8:00 PM" },
  ],
};

export const waLink = (text) =>
  `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(text || "Hello! I'd like to know more about your sarees.")}`;

export const VIDEOS = {
  hero: "/media/hero-reel.mp4",
  heroPoster: "/media/hero-reel-poster.jpg",
  reel: "/media/saree-reel-2.mp4",
  reelPoster: "/media/saree-reel-2-poster.jpg",
};

export const HERO_IMAGE = "/media/hero-reel-poster.jpg";

export const CATALOG = {
  name: "Designer Edit",
  subtitle: "Bridal Lookbook · 2026",
  pages: [
    "/media/edit-page-6.jpg",
    "/media/edit-page-13.jpg",
    "/media/edit-page-9.jpg",
    "/media/edit-page-19.jpg",
    "/media/edit-page-23.jpg",
    "/media/edit-page-26.jpg",
  ],
};

export const CATEGORIES = [
  {
    name: "Bridal",
    blurb: "Royal red & gold heritage lehngas — for the once-in-a-lifetime moment.",
    image: "/media/bridal_red.jpg",
  },
  {
    name: "Designer",
    blurb: "Hand-embroidered peacock motifs in blush couture for the modern muse.",
    image: "/media/bridal_pink.jpg",
  },
  {
    name: "Silk",
    blurb: "Pure Banarasi & Kanjeevaram in handloomed gold and crimson borders.",
    image: "/media/banarsi.jpg",
  },
  {
    name: "Festive",
    blurb: "Vermilion bandhani drapes & gilded borders for every celebration.",
    image: "/media/festival.jpg",
  },
];

export const PRODUCTS = [
  {
    id: "p1",
    title: "Champagne Tissue",
    cat: "Tissue",
    price: "On Inquiry",
    image: "/media/tissue.jpg",
    span: "row-span-2",
  },
  {
    id: "p2",
    title: "Royal Red Bridal Lehnga",
    cat: "Bridal",
    price: "On Inquiry",
    image: "/media/bridal_red.jpg",
  },
  {
    id: "p3",
    title: "Peacock Couture",
    cat: "Designer",
    price: "On Inquiry",
    image: "/media/bridal_pink.jpg",
  },
  {
    id: "p4",
    title: "Ivory Banarasi",
    cat: "Silk",
    price: "On Inquiry",
    image: "/media/banarsi.jpg",
    span: "row-span-2",
  },
  {
    id: "p5",
    title: "Vermilion Bandhani",
    cat: "Festive",
    price: "On Inquiry",
    image: "/media/festival.jpg",
  },
  {
    id: "p6",
    title: "Onyx Diamond Drape",
    cat: "Designer",
    price: "On Inquiry",
    image: "/media/saree-photo-2.jpg",
  },
  {
    id: "p7",
    title: "Emerald Embroidered",
    cat: "Bridal",
    price: "On Inquiry",
    image: "/media/saree-photo-1.jpg",
  },
];

export const TESTIMONIALS = [
  {
    name: "Aishwarya R.",
    role: "Bride, 2026",
    quote:
      "I found my wedding saree at New Varsha. The bridal consultation felt like family — patient, honest, and full of stories woven into every drape.",
  },
  {
    name: "Meera S.",
    role: "Repeat customer",
    quote:
      "Three generations of my family shop here. The Banarasi I bought last Diwali still gathers compliments at every gathering.",
  },
  {
    name: "Priya & Karan",
    role: "Wedding family",
    quote:
      "From the mother-in-law's Kanjeevaram to the bride's reception drape, every piece was hand-picked with care. Truly a heritage boutique.",
  },
];
